import React, {useState} from 'react';
import Avatar from '@material-ui/core/Avatar';
import Button from '@material-ui/core/Button';
import CssBaseline from '@material-ui/core/CssBaseline';
import TextField from '@material-ui/core/TextField';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import Link from '@material-ui/core/Link';
import Grid from '@material-ui/core/Grid';
import Box from '@material-ui/core/Box';
import LockOutlinedIcon from '@material-ui/icons/LockOutlined';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';
import Container from '@material-ui/core/Container';

import {Copyright} from '../../../components';
import { store } from 'react-notifications-component';
import { withRouter } from "react-router";

import { useFormik } from 'formik';

import {registerPublicUser, registerUser} from '../../../services/auth.service';
import { useAuth } from "../../../context/auth";
import {toastWarning} from "../../../utils/utils";
import LoaderWithBackDrop from "../../../components/LoaderWithBackDrop/LoaderWithBackDrop.comp";
import {LOCAL_STORAGE_KEYS} from "../../../utils/constants";
import PoweredbyDQ from "../../../assets/images/PoweredByDQ_Default.png";

const useStyles = makeStyles((theme) => ({
    paper: {
        // marginTop: theme.spacing(8),
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent:'center',
        minHeight: '93vh',
    },
    avatar: {
        margin: theme.spacing(1),
        backgroundColor: theme.palette.secondary.main,
    },
    form: {
        width: '100%', // Fix IE 11 issue.
        marginTop: theme.spacing(3),
    },
    submit: {
        background: "linear-gradient(to bottom, #E7466E 35%, #FFAC46 190%) !important",
        color: '#fff',
        '&:hover': {
            background: "linear-gradient(to bottom, #E7466E 35%, #FFAC46 190%) !important",
        },
        margin: theme.spacing(3, 0, 2),
    },
    footer: {
        marginTop: 'auto',
        textAlign: 'center',
        width:'full-width',
    },
}));

const Register = (props) => {
    const classes = useStyles();
    const [loading, setLoading] = useState(false);

    const { setAuthToken, setAuthUser } = useAuth();

    const formik = useFormik({
        initialValues: {
            email: '',
            password: '',
            confirm_password: '',
            remember_me: false
        },
        onSubmit: async (values) => {
            console.log('Form data => ', values);
            if (values.password !== values.confirm_password) {
                return toastWarning('Please provide the same password in both password fields!')
            }

            try {
                setLoading(true);
                const userFingerprint = localStorage.getItem(LOCAL_STORAGE_KEYS.user_fingerprint);
                const userRatingFingerprint = localStorage.getItem(LOCAL_STORAGE_KEYS.user_rating_fingerprint);
                const userDesiredSubscriptionPlan = localStorage.getItem(LOCAL_STORAGE_KEYS.user_desired_subscription_plan);
                let result;
                if (userFingerprint || userRatingFingerprint) {
                    result = await registerPublicUser(values.email, values.password, values.remember_me
                        ,userFingerprint, userRatingFingerprint, userDesiredSubscriptionPlan);
                } else {
                    result = await registerUser(values.email, values.password, values.remember_me);
                }

                if (result.data && result.data.user) {
                    await setAuthToken(result.data.auth_token);
                    await setAuthUser(result.data.user);
                    localStorage.setItem(LOCAL_STORAGE_KEYS.refresh_token, JSON.stringify(result.data.refresh_token));
                    props.history.push('/home');
                }
                setLoading(false);
            } catch (e) {
                // already toasted the error
                setLoading(false);
            }
        }
    });

    const goToLoginAction = () => {
        const userFingerprint = localStorage.getItem(LOCAL_STORAGE_KEYS.user_fingerprint);
        if (userFingerprint) {
            if (window.confirm('Current progress will be lost if you do not register. Do you want to continue to login?')) {
                props.history.push('/login');
            }
        } else {
            props.history.push('/login');
        }
    };

    return (
        <Container component="main" maxWidth="xs">
            <CssBaseline/>
            <div className={classes.paper}>
                {/*<Avatar className={classes.avatar}>*/}
                {/*    <LockOutlinedIcon/>*/}
                {/*</Avatar>*/}
                <Typography component="h1" variant="h3" style={{
                    background: 'linear-gradient(to right, #6A8EC9 10%, #8C74A7 35%, #D44C71 59%, #C91C6E 100%)',
                    color: 'transparent',
                    backgroundClip: 'text',
                    WebkitBackgroundClip: 'text',
                    WebkitTextFillColor: 'transparent',
                    fontWeight: 'semibold',
                }}>
                    Register
                </Typography>
                <form className={classes.form} noValidate onSubmit={formik.handleSubmit}>
                    <Grid container spacing={2}>
                        <Grid item xs={12}>
                            <TextField
                                style={{backgroundColor:'#fff'}}
                                variant="outlined"
                                required
                                fullWidth
                                id="firstName"
                                label="First Name"
                                name="firstName"
                                autoComplete="firstName"
                                onChange={formik.handleChange}
                                value={formik.values.firstName}
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <TextField
                                style={{backgroundColor:'#fff'}}
                                variant="outlined"
                                required
                                fullWidth
                                id="lastName"
                                label="Last Name"
                                name="lastName"
                                autoComplete="lastName"
                                onChange={formik.handleChange}
                                value={formik.values.lastName}
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <TextField
                                style={{backgroundColor:'#fff'}}
                                variant="outlined"
                                required
                                fullWidth
                                id="email"
                                label="Email Address"
                                name="email"
                                autoComplete="email"
                                onChange={formik.handleChange}
                                value={formik.values.email}
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <TextField
                                style={{backgroundColor:'#fff'}}
                                variant="outlined"
                                required
                                fullWidth
                                name="password"
                                label="Password"
                                type="password"
                                id="password"
                                autoComplete="current-password"
                                onChange={formik.handleChange}
                                value={formik.values.password}
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <TextField
                                style={{backgroundColor:'#fff'}}
                                variant="outlined"
                                required
                                fullWidth
                                name="confirm_password"
                                label="Confirm Password"
                                type="password"
                                id="confirm_password"
                                autoComplete="current-password"
                                onChange={formik.handleChange}
                                value={formik.values.confirm_password}
                            />
                        </Grid>
                        <FormControlLabel
                            control={<Checkbox
                                name="remember_me"
                                id="remember_me"
                                value={formik.values.remember_me}
                                onChange={formik.handleChange}
                                color="primary"
                            />}
                            label="Remember me"
                        />
                    </Grid>
                    <Button
                        type="submit"
                        fullWidth
                        variant="contained"
                        color="primary"
                        className={classes.submit}
                    >
                        Create Account
                    </Button>
                    <Grid container justify="center">
                        <Grid item>
                            <Link onClick={goToLoginAction} variant="body2">
                                Already have an account? Sign in
                            </Link>
                        </Grid>
                    </Grid>
                </form>
            </div>
            <footer className={classes.footer}>
                <Box pt={4}>
                    <Copyright/>
                </Box>
            </footer>
            <LoaderWithBackDrop loading={loading}/>
        </Container>
    );
}

export default withRouter(Register);